export const GET_REDEEM_REQUEST = "GET_REDEEM_REQUEST";

export const REDEEM_ACTION = "REDEEM_ACTION";

export const GET_SELLER_WITHDRAWAL_REQUEST = "GET_SELLER_WITHDRAWAL_REQUEST";

export const ADMIN_WALLET = "ADMIN_WALLET";

export const ACCEPTSELLERWITHDRAWALREQUEST = "ACCEPTSELLERWITHDRAWALREQUEST";

export const GET_ADMIN_EARNING = "GET_ADMIN_EARNING";

export const DECLINESELLERWITHDRAWALREQUEST = "DECLINESELLERWITHDRAWALREQUEST";

export const SET_REDEEM_LOADING = "SET_REDEEM_LOADING";


